import { memo } from "react";
import Rating from "react-rating";
import styles from "../hotel.module.css";
import starColor from '../../icons/star-color.svg';
import starTransparent from '../../icons/star-transparent.svg';

export default memo(function HotelMainRating({ hotel , reviews }) {
    return (
        <>
            <div className={styles.mainReviews}>
                <div className={styles.mainReviewsFirst}>
                    <h2>Customer Reviews</h2>
                    <div className={styles.overall}>{hotel?.overall_rating || 0}</div>
                    <Rating
                        initialRating={hotel?.overall_rating / 2 || 0}
                        stop={5}
                        emptySymbol={<img src={starTransparent} className={styles.starIcon} alt='' />}
                        fullSymbol={<img src={starColor} className={styles.starIcon} alt='' />}
                        readonly
                    />
                    <p>( {reviews || 0} Reviews )</p>
                </div>
                <div className={styles.mainReviewsSecond}>
                    {hotel.average_rates && Object.entries(hotel.average_rates)?.map(([key, value]) => (
                        <div key={key} style={{ marginBottom: "10px" }}>
                            <div className={styles.progressContainer}>
                                <p style={{ width: '70px' }}>{key}</p>
                                <div style={{ background: "#eee", borderRadius: "6px", height: "6px", display: 'flex', alignItems: "center", justifyContent: "space-between", width: "80%" }}>
                                    <div style={{ width: `${(value / 10) * 100}%`, background: "#6f2da8", height: "100%", borderRadius: "6px" }} />
                                </div>
                                <p style={{ width: '30px', textAlign: "right" }}>{value}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
})
